// Detect if IE 6-10, IE 11, or Edge
let isIE10 = !!window.ActiveXObject; // IE 6-10
let isIE11 = (document.body.style.msTouchAction !== undefined); // IE 10-11
let isEdge = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style && !window.navigator.msPointerEnabled; // MS Edge);

// Set expiration date for cookies (default to 1 year)
let date = new Date();
date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
let expires = "; expires=" + date.toGMTString();